import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';

import styles from './styles.css';

export type ShadowWrapperVariant = 'default' | 'shortOffer';

export type ShadowWrapperProps = {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  variant?: ShadowWrapperVariant;
};

export const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ children, onClick, variant = 'default' }) => {
  const deviceType = useDeviceType();

  return (
    <div
      role="button"
      className={cn(
        styles['root'],
        styles[deviceType],
        styles['clickable'],
        variant === 'shortOffer' && styles['root--short-offer'],
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

ShadowWrapper.displayName = 'ShadowWrapper';
